import React from 'react';
import {
  deactivateKeyboard,
  activateKeyboard,
} from '../../common/UI/state/actions';

/**
 * BaseForm is used to render the touchscreen keyboard.
 * If you need to override a forms state, make sure to extend the parent state.
 */
class BaseForm extends React.Component {
  keyboardUseToggle() {
    const { dispatch, ui = { keyboardActive: false } } = this.props;

    dispatch(ui.keyboardActive ? deactivateKeyboard() : activateKeyboard());
  }
}

export default BaseForm;



// WEBPACK FOOTER //
// ./src/components/forms/BaseForm.js